import { ProductModule } from '@erp/shared-types';
import type { TaskDefinition } from '../types/home-tasks.types';

/**
 * Task IDs - match the backend task IDs in getTaskCounts.ts
 */
export const TASK_IDS = {
  SALES_ORDER_DRAFTS_READY_FOR_APPROVAL:
    'sales-order-drafts-ready-for-approval',
  SALES_ORDER_DRAFTS_NEEDS_ATTENTION: 'sales-order-drafts-needs-attention',
  AP_INVOICES_MATCHED_READY: 'ap-invoices-matched-ready',
  AP_INVOICES_DRAFT_DISCREPANCIES: 'ap-invoices-draft-discrepancies',
} as const;

/**
 * Registry of all task definitions
 * Each task type defines how to display it and where to navigate on click
 */
export const TASK_DEFINITIONS: TaskDefinition[] = [
  {
    id: TASK_IDS.SALES_ORDER_DRAFTS_READY_FOR_APPROVAL,
    getTitle: (count) =>
      count === 1
        ? '1 sales order draft ready for approval'
        : `${count} Sales order drafts ready for approval`,
    urgency: 'high',
    targetPath: '/sales-orders',
    searchParams: { isReadyForApproval: 'true' },
    requiredModule: ProductModule.ORDER_MANAGEMENT,
  },
  {
    id: TASK_IDS.SALES_ORDER_DRAFTS_NEEDS_ATTENTION,
    getTitle: (count) =>
      count === 1
        ? '1 sales order draft needs attention'
        : `${count} Sales order drafts need attention`,
    urgency: 'normal',
    targetPath: '/sales-orders',
    searchParams: { status: 'RECEIVED' },
    requiredModule: ProductModule.ORDER_MANAGEMENT,
  },
  {
    id: TASK_IDS.AP_INVOICES_MATCHED_READY,
    getTitle: (count) =>
      count === 1
        ? '1 matched invoice ready for approval'
        : `${count} matched invoices ready for approval`,
    urgency: 'normal',
    targetPath: '/accounts-payable/invoices',
    searchParams: { status: ['MATCHED'] },
    requiredModule: ProductModule.AP_INVOICING,
  },
  {
    id: TASK_IDS.AP_INVOICES_DRAFT_DISCREPANCIES,
    getTitle: (count) =>
      count === 1
        ? '1 invoice draft needs review'
        : `${count} invoice drafts need review`,
    urgency: 'high',
    targetPath: '/accounts-payable/invoices',
    searchParams: { status: ['DRAFT'] },
    requiredModule: ProductModule.AP_INVOICING,
  },
];

/**
 * Get a task definition by ID
 */
export function getTaskDefinition(id: string): TaskDefinition | undefined {
  return TASK_DEFINITIONS.find((def) => def.id === id);
}
